import { render, staticRenderFns } from "./newsDetailsA.vue?vue&type=template&id=42117567&scoped=true&"
import script from "./newsDetailsA.vue?vue&type=script&lang=js&"
export * from "./newsDetailsA.vue?vue&type=script&lang=js&"
import style0 from "./newsDetailsA.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./newsDetailsA.vue?vue&type=style&index=1&id=42117567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42117567",
  null
  
)

export default component.exports